import type {
  HighlightedSeriesId,
  SelectState,
} from '../../core/components/interactions-state-helpers/types.js';
import type { XYChartState } from '../types/state.js';

// TODO: This reducers were copied from core because they don't include the explore state.
// We should move those back to core when all charts with InteractionsOverlay use the same tooltip.

export function reduceExploreReset(prev: XYChartState): XYChartState {
  return {
    ...prev,
    highlightedSeriesId: undefined,
    select: undefined,
  };
}

export function reduceExplorePin(highlightedSeriesId?: HighlightedSeriesId) {
  return (prev: XYChartState): XYChartState => ({
    ...prev,
    highlightedSeriesId,
  });
}

export function reduceExploreUnPin(prev: XYChartState): XYChartState {
  return {
    ...prev,
    select: undefined,
    highlightedSeriesId: undefined,
  };
}

export function reduceExploreSelect(select: SelectState) {
  return (prev: XYChartState): XYChartState => ({
    ...prev,
    select: {
      ...prev.select,
      ...select,
    },
    highlightedSeriesId: undefined,
  });
}

export function reduceExploreCancelSelect(prev: XYChartState): XYChartState {
  return {
    ...prev,
    select: undefined,
  };
}

export function reduceExploreCancelHighlight(prev: XYChartState): XYChartState {
  return {
    ...prev,
    highlightedSeriesId: undefined,
  };
}

export function reduceExploreCancelAll(prev: XYChartState): XYChartState {
  return {
    ...prev,
    select: undefined,
    highlightedSeriesId: undefined,
  };
}
